import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import StatusLabel from 'components/consumer/StatusLabel';
import IconPlay2 from 'components/icons/iconPlay2';
const LiveVideoPlayingBanner = t0 => {
  const $ = _c(11);
  const {
    category,
    title,
    slug: t1
  } = t0;
  const slug = t1 === undefined ? "" : t1;
  const t2 = `/videos/${slug}`;
  let t3;
  if ($[0] !== title) {
    t3 = !!title && <div className="text-lg font-bold text-gray md:text-2xl md:font-bold">{title}</div>;
    $[0] = title;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== category) {
    t4 = !!category && <div className="text-xs text-gray-light1 md:text-sm md:font-bold md:text-gray-light2">{category}</div>;
    $[2] = category;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== t3 || $[5] !== t4) {
    t5 = <div className="max-[767px]:flex-1">{t3}{t4}</div>;
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="items-center flex justify-center px-5 py-0 max-[767px]:pr-0 md:pl-0 animate-full-pulse"><StatusLabel color="red-dark"><div className="items-center flex [&_>_*:first-child]:mr-[5px]"><span>STREAMING NOW</span><IconPlay2 height={9} width={6} /></div></StatusLabel></div>;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t2 || $[9] !== t5) {
    t7 = <Link className="bg-white bottom-0 shadow-[0-4px_34px_rgba(0,0,0,.08)] flex px-5 py-4 sticky z-[1] hover:cursor-pointer md:flex-row-reverse md:justify-end md:px-[3.333vw] md:py-[1.2rem]" to={t2}>{t5}{t6}</Link>;
    $[8] = t2;
    $[9] = t5;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  return t7;
};
LiveVideoPlayingBanner.propTypes = {
  category: PropTypes.string,
  title: PropTypes.string,
  slug: PropTypes.string
};
export default LiveVideoPlayingBanner;